module.exports = "<th>Высота потолков</th>\n<td>\n  <div class=\"advanced-browser__item\">\n    <cian-serp-range source=\"filter.ceiling_height\"></cian-serp-range>\n    <span class=\"advanced-browser__label\">м</span>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/ceiling_height.html
// module id = 314
// module chunks = 0